@if (order$ | async; as order) {
  <div class="cx-summary col-12">
    <div class="border container-cx-summary border-dark">
      <app-order-summary [cart]="null" [orderDetailPage]="true" [order]="order"></app-order-summary>
    </div>
  </div>
}
